import ModelCategoryInterface from "../../../../interfaces/model/ModelCategoryInterface";
import SimpleBar from 'simplebar-react';
import {useState} from "react";

interface CategoryFiltersProps {
    categories: ModelCategoryInterface[];
    selectedCategories: ModelCategoryInterface[];
    addCategory: (category: ModelCategoryInterface) => void;
    removeCategory: (category: ModelCategoryInterface) => void;
}

export default function CategoryFilters({
    categories,
    selectedCategories,
    addCategory,
    removeCategory
}: CategoryFiltersProps) {
    const [isFolderActive, setIsFolderActive] = useState<boolean>(false)

    const isCategoryActive = (categoryIn: ModelCategoryInterface) => {
        return selectedCategories.map(category => category.name).includes(categoryIn.name)
    }

    return (
        <>
            {categories?.length > 1 && <div className="all-filters-block">
                <div className="all-filters__accord">
                    <p className={"all-filters__title all-filters__link f-exp " + (isFolderActive && 'active')}
                       onClick={() => {
                           setIsFolderActive(!isFolderActive)
                       }}>Категория <i
                        className="ico ico-arrow-bot-b"></i></p>
                    {isFolderActive && <div className="all-filters__col">
                        <div className="all-filters__height">
                            <SimpleBar style={{maxHeight: 230}} autoHide={false}>
                                <div className="scrollbar-inner">

                                    <ul className="filters__collapse-checkboxes">
                                        {categories.map(category => <li
                                            key={category.name}>
                                            <div
                                                className={"form-checkbox " + (isCategoryActive(category) && "active")}
                                                onClick={() => isCategoryActive(category) ? removeCategory(category) : addCategory(category)}>
                                                <label className={"label-dot"}></label>
                                                <label className="label-text">{category.name}</label>
                                            </div>
                                        </li>)}
                                    </ul>

                                </div>
                            </SimpleBar>
                        </div>
                    </div>}
                </div>
            </div>}
            {categories?.length > 1 && <ul className="all-filters__activated">
                {selectedCategories.map((category) => <li key={category.name}><a
                    className="ico-cont"
                    href="/">
                    <i className="ico ico-right ico-delete"
                       onClick={(event) => {
                           event.preventDefault()
                           removeCategory(category)
                       }}></i>{category.name}</a></li>)}
            </ul>}
        </>
    );
}